module.exports = __webpack_public_path__ + "static/media/btn_points.b8f84f56.svg";